module.exports = __webpack_public_path__ + "2157616f5d411423abd0aa2c5853a228.jpg";